import { ReactNode } from "react";
import "./KebabMenu.css";

interface KebabMenuProps {
  onToggle: () => void;
  children: ReactNode;
  containerClassName?: string;
  triggerClassName?: string;
  dropdownClassName?: string;
  isOpen?: boolean;
  openClassName?: string;
  closedClassName?: string;
  triggerTestId?: string;
  triggerLabel?: string;
}

const KebabMenu: React.FC<KebabMenuProps> = ({
  onToggle,
  children,
  containerClassName = "dropdown-container",
  triggerClassName = "three-dots kebabMenu",
  dropdownClassName = "dropdown",
  isOpen = false,
  openClassName = "block",
  closedClassName = "hidden",
  triggerTestId = "dots_menu",
  triggerLabel = "Open menu",
}) => {
  return (
    <div className={containerClassName}>
       <button
        type={undefined}
        className={triggerClassName}
        data-testid={triggerTestId}
        aria-label={triggerLabel}
        title={triggerLabel}
        onClick={onToggle}
      ></button>
      <div className={`${dropdownClassName} ${isOpen ? openClassName : closedClassName}`}>
        {children}
      </div>
    </div>
  );
};

export default KebabMenu;
